import { RequestBuilder } from "@lernetz/request";

let req: RequestBuilder = new RequestBuilder( '/icons.svg' );

export function set( r: RequestBuilder ) {
    req = r;
}

export function get(): RequestBuilder {
    return req;
}
